import React from 'react'
import { Button, Form, FormGroup, Input, InputGroup, Label, Nav, NavItem, InputGroupAddon, NavLink } from 'reactstrap'
import tapOrClick from 'react-tap-or-click'
import Loader from 'react-loader-spinner'
import '../../../stylesheets/odometer-theme-default.css'
import { subscriptionHelpers } from '../../../dataHelpers'
import { getStorage, TOKEN_STORAGE_KEY, authRedirect } from '../../../dataHelpers/authenticationHelpers'
import classnames from 'classnames'
import '../../../stylesheets/ControllerDashboard.css'
import AppError from "../../../models/AppError"
import { ErrorModal } from './../../ui'
import EditPlanIcon from 'react-icons/lib/fa/edit'
import AddPlanIcon from 'react-icons/lib/fa/plus-square'
import SubsListIcon from 'react-icons/lib/fa/list'
import {
    NO_DISCOUNT_LABEL, SELECT_DISC_LABEL, NO_VALUE, ENTER_DISCOUNT_VAL, VALID_DISCOUNT_VAL,
    SUCCESS, SUCCESS_DISCOUNT_LABEL_UPDATE, NO_DISCOUNT_LABEL_SELECT
} from '../../../constants'

class EditDiscountLabel extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: '2',
            errors: [],
            currentControllerPage: 1,
            loading: false,
            discountVal: '',
            discountLabelList: [],
            discountLabelId: ''
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.submitForm = this.submitForm.bind(this)
        this.onChangeDiscountLabel = this.onChangeDiscountLabel.bind(this)
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    componentDidMount() {
        this.getDiscountLabelList(this.token)
    }

    async onChangeDiscountLabel(evt) {
        try {
            let selectDiscountLabel = evt.target.value
            if (selectDiscountLabel) {
                let discountValFilter = this.state.discountLabelList.filter(e => e.id === parseInt(selectDiscountLabel))
                let discountValue = discountValFilter[0].discount
                this.setState({ discountVal: discountValue, discountLabelId: selectDiscountLabel })
            }
        } catch (error) {
            console.log(error)
        }
    }

    async getDiscountLabelList(token) {
        try {
            let discountData = await subscriptionHelpers.getDiscountLabelList(token)
            if (!discountData.error) {
                this.setState({ discountLabelList: discountData })
            } else {
                this.setState({ errors: [discountData.error] })
            }
        } catch (error) {
            console.log(error)
        }
    }

    async submitForm(e) {
        e.preventDefault()
        this.setState({ loading: true })
        let { discountLabelId, discountVal } = this.state
        if (!discountLabelId || discountLabelId === '') {
            let appError = new AppError(NO_DISCOUNT_LABEL_SELECT, SELECT_DISC_LABEL)
            await this.setState({ errors: [appError], loading: false })
            return
        }
        if (!discountVal || discountVal === '') {
            let appError = new AppError(NO_VALUE, ENTER_DISCOUNT_VAL)
            await this.setState({ errors: [appError], loading: false })
            return
        }
        if (!(discountVal.toString()).match(/^\d+(\.\d+)?$/)) {
            let appError = new AppError(NO_VALUE, VALID_DISCOUNT_VAL)
            await this.setState({ errors: [appError], loading: false })
            return
        }

        let discountLabelResponse = await subscriptionHelpers.editDiscountLabel(this.token, discountLabelId, discountVal)
        if (!discountLabelResponse.error) {
            let appError = new AppError(SUCCESS, SUCCESS_DISCOUNT_LABEL_UPDATE)
            await this.setState({ errors: [appError], loading: false, discountVal: '' })
            this.getDiscountLabelList(this.token)
            return
        } else {
            this.setState({ errors: [discountLabelResponse.error], discountVal: '' })
        }
    }

    render() {
        let { loading, dealersList, errors, discountVal, discountLabelList } = this.state

        return (<div>
            <div className="m-0">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/discountlabelsetting`, this.props.history)) })}
                        >
                            <AddPlanIcon />&ensp;Create Discount Level
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/editdiscountlabel`, this.props.history)) })}
                        >
                            <EditPlanIcon />&ensp;Edit Discount Level
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/discountlabellist`, this.props.history)) })}>
                            <SubsListIcon />&ensp;Available Discount Levels
                            </NavLink>
                    </NavItem>
                </Nav>
            </div>
            <div className="row justify-content-center align-items-center bg-light large-rounded border-light-sf-orange p-0 pb-4">
                <h1 className="text-center mb-4 form-head col-12">Edit Discount Level</h1>
                {loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    <Form onSubmit={this.submitForm} className="col-lg-6 col-md-8 col-sm-10">
                        <FormGroup>
                            <br />
                            <div>
                                <div className="text-left">
                                    <Label>Discount Level</Label>
                                    <InputGroup>
                                        <Input type="select" name="selectDiscountLabel"
                                            //onChange={(evt) => this.setState({discountVal: evt.target.value})} 
                                            onChange={this.onChangeDiscountLabel}
                                        >
                                            <option value="">&ensp;Select Discount Level</option>
                                            {(discountLabelList && discountLabelList.length > 0) ? discountLabelList.map((dis) => (
                                                <option key={`${dis.id}`}
                                                    value={dis.id}>&ensp;{dis.discount_label}</option>
                                            )) :
                                                <option>&ensp;No Discount Label</option>
                                            }
                                        </Input>
                                    </InputGroup>
                                </div>
                                <br />
                                <div className="text-left">
                                    <Label>Discount Value (%)</Label>
                                    <InputGroup>
                                        <Input type="discountval"
                                            placeholder={`0`}
                                            value={discountVal}
                                            onChange={(evt) => this.setState({ discountVal: evt.target.value })}
                                            maxLength={5}
                                        />
                                        <InputGroupAddon addonType="append">%</InputGroupAddon>
                                    </InputGroup>
                                </div>
                            </div>
                        </FormGroup>
                        <Button className="mt-3">Update Discount</Button>
                    </Form>
                }
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                        modal={true}
                        toggle={() => (this.dismissError(appError))}
                        text={appError.text}
                        title={appError.title} />
                )}
            </div>
        </div>)
    }
}
export default EditDiscountLabel



// WEBPACK FOOTER //
// ./src/components/pages/subscription/EditDiscountLabel.js